import Section from "@/components/ui/section";
import React from "react";
import Image from "next/image";
import Link from "next/link";
import Carousel from "@/components/ui/carousel/carousel";
import { SwiperSlide } from "swiper/react";
export default function Clients() {
  const press = [
    {
      logo: "/images/clients/LEHS-WISH-Logo.png",
      title: "Wish Foundation (LEHS)",
      link: "https://wishfoundationindia.org/",
    },
    {
      logo: "/images/clients/ChildFund-Alliance-white-on-green.png",
      title: "ChildFund",
      link: "https://www.childfund.org/",
    },
    // {
    //   logo: "/images/DAI-logo.webp",
    //   title: "Dignity Alliance Foundation",
    //   link: "https://dignityallianceinternational.org/",
    // },
    {
      logo: "/images/clients/ISRN Logo.png",
      title: "ISRN",
      link: "https://isrn.in/",
    },
    {
      logo: "/images/action-against-hunger.png",
      title: "Action on Hunger & Poverty Foundation",
      link: "https://actionagainsthunger.in/",
    },
    // {
    //   logo: "/images/clients/js.png",
    //   title: "Jan Sahas USA INC",
    //   link: "",
    // },
    {
      logo: "/images/DAI-logo.webp",
      title: "Dignity Alliance International",
      link: "https://dignityallianceinternational.org/",
    },
  ];
  const breakpoints = {
    1280: {
      slidesPerView: 5,
      spaceBetween: 30,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
    },
    991: {
      slidesPerView: 4.4,
      spaceBetween: 20,
      slidesOffsetBefore: 64,
      slidesOffsetAfter: 64,
    },
    // when window width is >= 768px
    768: {
      slidesPerView: 3.1,
      spaceBetween: 20,
      slidesOffsetBefore: 32,
      slidesOffsetAfter: 32,
    },
    325: {
      slidesPerView: 2.4,
      spaceBetween: 15,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16,
    },
  };
  return (
    <div className="bg-[#fafafa]">
      <div className="flex flex-col w-full mx-auto gap-8 lg:px-[5vw]">
        <p className="font-bold text-[#292929]/70 text-center mx-auto lg:text-lg text-base lg:px-0 md:px-8 px-4">
          We have worked with:
        </p>
        {/* <div className="grid md:grid-cols-4 grid-cols-2 auto-rows-auto items-center gap-20 w-fit mx-auto">
          {press.map((partner, key) => (
            <div
              key={"seenBy" + key}
              className="relative md:w-[102px] md:h-[42px] w-[100px] h-[30px]"
            >
              <Image
                src={partner?.logo}
                alt={"partner icon"}
                sizes="(max-width: 479px) 500px, 500px"
                fill
                className="w-full h-full object-contain object-center"
              />
            </div>
          ))}
        </div> */}
        <Carousel
          slidesPerView={6}
          spaceBetween={30}
          loop={false}
          className="featureCarousel w-full my-8"
          breakpoints={breakpoints}
          navigation={false}
          autoplay={{
            delay: 4500,
            disableOnInteraction: false,
          }}
          mousewheel={{
            forceToAxis: true,
            sensitivity: 1,
            releaseOnEdges: true,
          }}
          showNavAbove={false}
          title="Press & Media"
        >
          {press.map((partner, key) => (
            <SwiperSlide key={"partner" + key}>
              <a
                href={partner?.link ?? "#"}
                target="_blank"
                rel="noreferrer"
                className="w-full flex items-center justify-center bg-white rounded-2xl p-4"
              >
                <div className="relative md:w-[155px] md:h-[105px] w-[100px] h-[75px] rounded-2xl">
                  <Image
                    src={partner?.logo}
                    alt={partner?.title ?? "partner icon"}
                    sizes="(max-width: 479px) 500px, 500px"
                    fill
                    className="w-full h-full object-contain object-center"
                  />
                </div>
              </a>
            </SwiperSlide>
          ))}
        </Carousel>
        <p className="text-center lg:max-w-[800px] mx-auto mb-12 px-4 md:px-8 lg:px-16">
          At Soulscale, we are dedicated to delivering excellence in every
          service we offer. Partner with us to unlock your organization&apos;s
          potential and drive sustainable success.
        </p>
      </div>
    </div>
  );
}
